import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeleteFill = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M19.2 6h-2.48c-.383-1.745-2.02-2.998-3.92-3h-1.6c-1.9.002-3.537 1.255-3.92 3H4.8c-.442 0-.8.336-.8.75s.358.75.8.75h.8v9.75c.003 2.07 1.792 3.747 4 3.75h4.8c2.208-.003 3.997-1.68 4-3.75V7.5h.8c.442 0 .8-.336.8-.75S19.642 6 19.2 6Zm-8 9.75c0 .414-.358.75-.8.75-.442 0-.8-.336-.8-.75v-4.5c0-.414.358-.75.8-.75.442 0 .8.336.8.75v4.5Zm3.2 0c0 .414-.358.75-.8.75-.442 0-.8-.336-.8-.75v-4.5c0-.414.358-.75.8-.75.442 0 .8.336.8.75v4.5ZM8.937 6c.34-.898 1.246-1.499 2.263-1.5h1.6c1.017.001 1.923.602 2.263 1.5H8.937Z"
	})
});
const ForwardRef = forwardRef(SvgDeleteFill);
export default ForwardRef;
